import { defineStore } from "pinia";
import http from "@/http";
import { LIST_DOCUMENTO, ADD_DOCUMENTO, UPDATE_DOCUMENTO, DEL_DOCUMENTO } from "@/http/url";

export const useDocumentoStore = defineStore("DocumentoStore", {
  state: () => {
    return {
      documentos: [],
      loaded: false,
    };
  },
  
  persist: { storage: sessionStorage },

  //Os actions não precisam das mutations, acessam diretamente o state
  actions: {
    LISTAR_DOCUMENTOS() {
      return new Promise((resolve, reject) => {
        http
          .get(LIST_DOCUMENTO)
          .then((response) => {
            this.documentos = response.data;
            this.loaded = true;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    CADASTRAR_DOCUMENTO(documento) {
      return http
        .post(ADD_DOCUMENTO, documento)
        .then((response) => this.documentos.push(response.data))
        .catch((erro) => {
          console.log(erro);
        });
    },

    ALTERAR_DOCUMENTO(documento) {
      return http.put(`${UPDATE_DOCUMENTO + documento.id}`, documento);
    },

    REMOVER_DOCUMENTO(id) {
      return http
        .delete(`${DEL_DOCUMENTO + id}`)
        .then(() => (this.documentos = this.documentos.filter((d) => d.id != id)));
    },

  },

  //Os getters precisam do state para acesso externo aos componentes
  getters: {
    getDocumentos() {      
      return this.documentos;
    },

    getDocumentoLoad(state) {
      return state.loaded;
    },

    getFilterDocumentos: (state) => {
      return (filtro) => state.documentos.filter((d) => !filtro || d.descricao.includes(filtro));
    },
  },
});